// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"fafc003c","142":"e6806216","178":"7092acdc","327":"45a2c3eb","333":"e9fb6c07","343":"ab9b0b47","397":"96acd819","489":"45a2c3eb","633":"28ad79c2","850":"fafc003c","979":"fafc003c"}[chunkId] + ".chunk.css";
};